// 📁 src/layouts/Category/index.js
import { useState, useEffect, useMemo } from "react";
import PropTypes from "prop-types";
import { searchCategorys } from "api/categoryService";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbarCustom from "examples/Navbars/DashboardNavbarCustom";
import { Grid } from "@mui/material";
import SoftBox from "components/SoftBox";
import Breadcrumb from "../../components/Breadcrumb";
import SearchCategoryManager from "./data/SearchCategoryManager";
import CategoryManagerTable from "./data/CategoryManagerTable";

function CategoryTables({ workingPage, childPage }) {
  const [totalElements, setTotalElements] = useState(0);
  const [curPage, setCurPage] = useState(0);
  const [rowsCount, setRowsCount] = useState(10);
  const [categoryData, setCategoryData] = useState([]);
  const [searchData, setSearchData] = useState({
    code: "",
    name: "",
    status: -1,
    page: curPage,
    size: rowsCount,
  });

  useEffect(() => {
    setSearchData((prev) => ({ ...prev, page: curPage, size: rowsCount }));
  }, [curPage, rowsCount]);

  useEffect(() => {
    searchCategorys(searchData).then((data) => {
      if (data?.object) {
        setCategoryData(data.object.datas || []);
        setTotalElements(data.object.totals || 0);
      }
    });
  }, []);

  const clickToSearch = () => {
    setCurPage(0);
    searchCategorys({ ...searchData, page: 0 }).then((data) => {
      if (data?.object) {
        setCategoryData(data.object.datas || []);
        setTotalElements(data.object.totals || 0);
      }
    });
  };

  const refreshDataAfterChange = () => {
    searchCategorys(searchData).then((data) => {
      if (data?.object) {
        setCategoryData(data.object.datas || []);
        setTotalElements(data.object.totals || 0);
      }
    });
  };

  const renderData = useMemo(
    () => (
      <CategoryManagerTable
        data={categoryData}
        totalElements={totalElements}
        curPage={curPage}
        setCurPage={setCurPage}
        rowsCount={rowsCount}
        setRowsCount={setRowsCount}
        refreshDataAfterChange={refreshDataAfterChange}
      />
    ),
    [curPage, rowsCount, totalElements, categoryData]
  );

  return (
    <DashboardLayout>
      <DashboardNavbarCustom page={workingPage} childPage={childPage} />
      <SoftBox py={3}>
        <SoftBox mb={3}>
          <Grid container>
            <Grid item xs={0.2} sm={0.2} xl={0.2} />
            <Grid item xs={11.6} sm={11.6} xl={11.6}>
              <Breadcrumb
                items={[
                  {
                    label: "Quản lý danh mục",
                  },
                ]}
              />
              <SearchCategoryManager
                clickSearch={clickToSearch}
                setSearchData={setSearchData}
                searchData={searchData}
                refreshDataAfterChange={refreshDataAfterChange}
              />
            </Grid>
            <Grid item xs={0.2} sm={0.2} xl={0.2} />
            <Grid item xs={0.2} sm={0.2} xl={0.2} />
            <Grid item xs={11.6} sm={11.6} xl={11.6}>
              {renderData}
            </Grid>
            <Grid item xs={0.2} sm={0.2} xl={0.2} />
          </Grid>
        </SoftBox>
      </SoftBox>
    </DashboardLayout>
  );
}

CategoryTables.defaultProps = {
  workingPage: "",
  childPage: [],
};

CategoryTables.propTypes = {
  workingPage: PropTypes.string,
  childPage: PropTypes.arrayOf(PropTypes.string),
};

export default CategoryTables;
